import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/TrusteeCard.module.css";
import parsePhoneNumber from "libphonenumber-js";
import { LanguageContext } from "../../Context/changeLanguageProvider";

function TrusteeCard({ name, aware, email, phone_number, information, popup }) {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.TrusteeCard
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.TrusteeCard);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  let phoneNumber;
  if (phone_number) {
    phoneNumber = phone_number;

    if (phoneNumber.startsWith("+")) {
      phoneNumber = phoneNumber.replace(/^\+/, "");
    }
  }

  const phoneParsed = parsePhoneNumber(
    "+" + phoneNumber
  )?.formatInternational();

  const [showFullDescription, setShowFullDescription] = useState(false);

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const textMaxLength = 150;

  return (
    <div className={`${styles.main} ${popup ? styles.main_popup : ""}`}>
      <div className={styles.upper}>
        <div className={styles.left}>
          <div className={styles.logo}>{name}</div>
        </div>
        <div className={styles.right}>
          {aware === "true" ? (
            <div className={styles.awareness_div}>
              <div className={styles.aware} />
              <span>{dublicatedcontent?.aware}</span>
            </div>
          ) : (
            <div className={styles.awareness_div}>
              <div className={styles.not_aware} />
              <span>{dublicatedcontent?.not_aware}</span>
            </div>
          )}

          {popup && (
            <>
              <div className={styles.userinfo}>
                <div className={styles.wallet}>
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.7619 1.7619L4.02381 3.5L2.2619 1.7619L4.02381 0L5.7619 1.7619ZM8 4L6.26191 5.7619L4.52381 4L6.26191 2.2619L8 4ZM3.52381 4L1.7619 5.7619L0 4L1.7619 2.2619L3.52381 4ZM5.7619 6.2619L4.02381 8L2.2619 6.2619L4.02381 4.5L5.7619 6.2619Z"
                      fill="#26323E"
                    />
                  </svg>
                </div>
                <span>{email}</span>
              </div>
              {phone_number && (
                <div className={styles.userinfo}>
                  <div className={styles.wallet}>
                    <svg
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.7619 1.7619L4.02381 3.5L2.2619 1.7619L4.02381 0L5.7619 1.7619ZM8 4L6.26191 5.7619L4.52381 4L6.26191 2.2619L8 4ZM3.52381 4L1.7619 5.7619L0 4L1.7619 2.2619L3.52381 4ZM5.7619 6.2619L4.02381 8L2.2619 6.2619L4.02381 4.5L5.7619 6.2619Z"
                        fill="#26323E"
                      />
                    </svg>
                  </div>
                  <span>{phoneParsed}</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {popup && (
        <>
          {information !== "" ? (
            <div className={styles.lower}>
              <div className={styles.grey_title}>
                {dublicatedcontent?.additional_information}
              </div>
              <div className={styles.information}>
                {information.length > textMaxLength ? (
                  showFullDescription ? (
                    <p>{information}</p>
                  ) : (
                    <p>{information.slice(0, textMaxLength)}...</p>
                  )
                ) : (
                  <p>{information}</p>
                )}
                {information.length > textMaxLength && (
                  <span
                    className={styles.read_more}
                    onClick={toggleDescription}
                  >
                    {showFullDescription
                      ? content.trusteeCardText1
                      : dublicatedcontent.dublicatedText68}
                  </span>
                )}
              </div>
            </div>
          ) : null}
        </>
      )}
      {!popup && (
        <>
          <div className={styles.userinfo}>
            <div className={styles.wallet}>
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.7619 1.7619L4.02381 3.5L2.2619 1.7619L4.02381 0L5.7619 1.7619ZM8 4L6.26191 5.7619L4.52381 4L6.26191 2.2619L8 4ZM3.52381 4L1.7619 5.7619L0 4L1.7619 2.2619L3.52381 4ZM5.7619 6.2619L4.02381 8L2.2619 6.2619L4.02381 4.5L5.7619 6.2619Z"
                  fill="#26323E"
                />
              </svg>
            </div>
            <span>{email}</span>
          </div>
          {phone_number && (
            <div className={styles.userinfo}>
              <div className={styles.wallet}>
                <svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.7619 1.7619L4.02381 3.5L2.2619 1.7619L4.02381 0L5.7619 1.7619ZM8 4L6.26191 5.7619L4.52381 4L6.26191 2.2619L8 4ZM3.52381 4L1.7619 5.7619L0 4L1.7619 2.2619L3.52381 4ZM5.7619 6.2619L4.02381 8L2.2619 6.2619L4.02381 4.5L5.7619 6.2619Z"
                    fill="#26323E"
                  />
                </svg>
              </div>
              <span>{phoneParsed}</span>
            </div>
          )}

          {information !== "" ? (
            <div className={styles.lower}>
              <div className={styles.grey_title}>
                {dublicatedcontent?.additional_information}
              </div>
              <div className={styles.information}>
                {information.length > textMaxLength ? (
                  showFullDescription ? (
                    <p>{information}</p>
                  ) : (
                    <p>{information.slice(0, textMaxLength)}...</p>
                  )
                ) : (
                  <p>{information}</p>
                )}
                {information.length > textMaxLength && (
                  <span
                    className={styles.read_more}
                    onClick={toggleDescription}
                  >
                    {showFullDescription
                      ? content.trusteeCardText1
                      : dublicatedcontent.dublicatedText68}
                  </span>
                )}
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}

export default TrusteeCard;
